import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PardotForm } from '@periscopes/general/pardot-forms';

import { MetadataContainer, MetadataEntry } from '@periscopes/general/metadata';
import { PeriscopePardotLandingPageMetadata, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback, useMemo } from 'react';
import { usePeriscopeActions, usePeriscopeMetadata } from '@hooks';

export interface PardotLandingPageMetadataTabProps {
	index: number;
	sonarObjectId: number;
}

export const PardotLandingPageMetadataTab: React.FC<PardotLandingPageMetadataTabProps> = ({ index, sonarObjectId }) => {
	const { openPeriscope } = usePeriscopeActions();

	const { loading, metadata } = usePeriscopeMetadata<PeriscopePardotLandingPageMetadata>(
		sonarObjectId,
		SonarObjectType.PardotLandingPage
	);

	const handleFormClick = useCallback(() => {
		if (!metadata?.form?.sonarObjectId) {
			return;
		}

		const { form } = metadata;

		openPeriscope({
			id: form.sonarObjectId,
			name: form.displayName,
			openedFromIndex: index,
			type: form.sonarObjectType ?? SonarObjectType.PardotForm
		});
	}, [ index, openPeriscope, metadata ]);

	const metadataEntries = useMemo(() => {
		if (!metadata) {
			return [];
		}

		const entries: MetadataEntry[] = [
			{
				label: COPY_SPECIFIC.CAMPAIGN,
				type: 'string',
				value: metadata.campaign
			},
			{
				label: COPY_SPECIFIC.TITLE,
				type: 'string',
				value: metadata.title
			},
			{
				label: COPY_SPECIFIC.LINK,
				type: 'string',
				value: metadata.link
			}
		];

		return entries;
	}, [ metadata ]);

	if (loading || !metadata) {
		return <LoadingSpinner spinning />;
	}

	return (
		<>
			<MetadataContainer
				entries={ metadataEntries }
				title={ COPY_SPECIFIC.LANDING_PAGE_INFORMATION } />
			{ metadata.form && <PardotForm
				entity={ metadata.form }
				onFormClick={ handleFormClick } /> }
		</>
	);
};
